// Player text rules of the server (backend/app/helpers/text.py): no control, invisible format or lone surrogate
// character, and a length in code points.
const REFUSED = /[\p{Cc}\p{Cf}\p{Cs}]/gu;

export const codePoints = value => [...value].length;

// Line breaks: CR, LF, VT, FF, NEL, LS and PS.
export const LINE_BREAKS = /[\r\n\v\f\u0085\u2028\u2029]+/g;

const tidy = text => [...text.replace(LINE_BREAKS, ' ').replace(/\t/g, ' ').replace(REFUSED, '')];

// The field's new value: each run of line breaks and each tab becomes a space (as QuestionField did), refused
// characters go, and past `max` code points only the inserted text is cut. `caret` is the field's caret after the
// change (`selectionEnd`): the text after it is the end of `prev` that stays, and the text before it starts with the
// part of `prev` that stays; what is between them was inserted.
export const fitText = (prev, next, max, caret) => {
  const clean = tidy(next);
  if (clean.length <= max) return clean.join('');
  const old = [...prev];
  const end = Math.min(tidy(next.slice(caret ?? next.length)).length, old.length, clean.length);
  let start = 0;
  while (start < old.length - end && start < clean.length - end && old[start] === clean[start]) start += 1;
  const room = Math.max(max - start - end, 0);
  return clean.slice(0, start + room).concat(clean.slice(clean.length - end)).join('');
};
